import {
  Card,
  CardBody,
  FunctionCard,
  Image,
  Paragraph,
  Separator,
  useMatchMediaTierProp,
} from "@george-labs.com/design-system"
import { useTranslation } from "react-i18next"
import { useOfferData } from "../../app/hooks"
import { useOfferScreenFlow } from "../../hooks/useOfferScreenFlow"
import OfferInfoComponent from "./OfferInfoPage"
import { OfferNavButtons } from "./OfferNavButtons"

const IMAGE_URL = "./assets/technical_error.png"

const OfferEvaluationError = () => {
  const { t } = useTranslation()
  const offerData = useOfferData()
  const { setNextStep } = useOfferScreenFlow()
  const headerTitle = t("offers.evaluation.titleError")
  const nextButtonText = t("offers.button.retry")

  const textContent = <Paragraph>{t("offers.evaluation.text.error")}</Paragraph>

  const nextButtonHandler = () => {
    setNextStep(offerData?.caseId)
  }

  const navButtonsContent = (
    <OfferNavButtons
      nextButtonText={nextButtonText}
      onNextButtonClicked={nextButtonHandler}
    />
  )

  const pageContent = useMatchMediaTierProp({
    xs: (
      <OfferInfoComponent
        buttonText={nextButtonText}
        headerText={headerTitle}
        imageUrl={IMAGE_URL}
        onButtonClicked={nextButtonHandler}
        textContent={textContent}
      />
    ),
    md: (
      <Card nested={false}>
        <FunctionCard
          padding={Card.PADDING.LARGE}
          heading={headerTitle}
          indicator={<Image src={IMAGE_URL} alt="" />}
        >
          {textContent}
        </FunctionCard>

        <Separator />

        <CardBody>{navButtonsContent}</CardBody>
      </Card>
    ),
  })

  return <>{pageContent}</>
}

export default OfferEvaluationError
